/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {VerifyRecoveryOtpRequest} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'
import {VerifyRecoveryOtpResponse} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'


export const verifyRecoveryOtp = (request: VerifyRecoveryOtpRequest, options?: CashRequestOptions) => post<VerifyRecoveryOtpRequest, VerifyRecoveryOtpResponse>("/2.0/cash/verify-recovery-otp", request, {...options, rejectOnError: true })